<div class="Typography" style="padding-bottom: 4px;padding-bottom: 4px; width: 100%; height: 100%; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
    <div class="H6" style="align-self: stretch; color: rgba(0, 0, 0, 0.87); font-size: 20px; font-family: Roboto; font-weight: 500; line-height: 32px; letter-spacing: 0.15px; word-wrap: break-word">Update Password</div>
</div>
<form [formGroup]="changePassword">
    <div class="container">
      <div class="row">
        <mat-form-field appearance="outline">
          <mat-label>Current password </mat-label>
          <input matInput placeholder="Current confirmation" [type]="hideCurrent ? 'password' : 'text'"
            formControlName="currentPassword" required>

          <mat-icon matSuffix (click)="hideCurrent = !hideCurrent">{{hideCurrent ? 'visibility_off' : 'visibility'}}</mat-icon>

        </mat-form-field>
        <mat-error *ngIf="passwordMismatch">Password and confirm password fields must match.</mat-error>
      </div>
        <div class="row">
            <mat-form-field appearance="outline">
                <mat-label>New password</mat-label>
                <input matInput placeholder="New password" [type]="hide ? 'password' : 'text'"
                  formControlName="password" required>
                <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                <mat-error>Password is required</mat-error>
              </mat-form-field>
              <app-app-password-strength [passwordToCheck]="changePassword.value.password??''"
                (passwordStrength)="onPasswordStrengthChanged($event)"
                style="width: 100%;"></app-app-password-strength>
        </div>

        <div class="row">
            <mat-form-field appearance="outline">
              <mat-label>New password confirmation</mat-label>
              <input matInput placeholder="New password confirmation" [type]="hideC ? 'password' : 'text'"
                formControlName="confirmPassword" required>

              <mat-icon matSuffix (click)="hideC = !hideC">{{hideC ? 'visibility_off' : 'visibility'}}</mat-icon>

            </mat-form-field>
            <mat-error *ngIf="passwordMismatch">Password and confirm password fields must match.</mat-error>
          </div>
          <div class="Dialogactions" style="width: 100%; height: 100%; padding: 8px; justify-content: flex-end; align-items: center; gap: 8px; display: inline-flex">
            <button (click)="dialogRef.close()" mat-stroked-button mat-button mat-dialog-close class="button-stepper-allow-outline">
                GO BACK
                <mat-icon>arrow_left_alt</mat-icon>
             </button>
             <button [disabled]="!changePassword.valid"  [ngClass]="{'button-stepper-allow': changePassword.valid ,'button-stepper': changePassword.invalid  }"  
             mat-stroked-button mat-button (click)="save()" class="button-stepper-allow">SAVE <mat-icon>save</mat-icon></button>
        </div>
        
    </div>
</form>